import gql from 'graphql-tag'
import { User } from '~/graphql/fragments/user.js'

export const GET_MY_ACADEMY_PLAYLISTS = gql`
  query academyMyPlaylists(
    $schoolIds: [Int]
    $search: String
    $statuses: [PlaylistUserProgressStatus]
    $assignedBys: [Int]
    $sortField: MyPlaylistAllowedSortField
    $sortDirection: SortDirection
    $limit: Int
    $page: Int
  ) {
    academyMyPlaylists(
      schoolIds: $schoolIds
      search: $search
      statuses: $statuses
      assignedBys: $assignedBys
      sortField: $sortField
      sortDirection: $sortDirection
      limit: $limit
      page: $page
    ) {
      meta {
        total
        page
        limit
      }
      data {
        name
        id
        desc
        slug
        status
        cover
        totalTime
        updatedAt
        user {
          fullName
          media {
            url
          }
          id
        }
        playlistAssign {
          id
          type
          assignTo
          updatedAt
        }
        coursePlaylists {
          course {
            id
            topics {
              mediaFromTime
              mediaToTime
            }
            duration
          }
        }
        playlistUserProgresses {
          status
          userId
        }
      }
    }
  }
`

export const GET_PLAYLIST_INFO = gql`
  query academyPlaylist($slug: String!) {
    academyPlaylist(slug: $slug) {
      user {
        fullName
        media {
          url
        }
      }
      coursePlaylists {
        insertedAt
        course {
          courseEnrolls {
            insertedAt
            id
            userId
            course {
              updatedAt
            }
          }
          id
          duration
          name
          type
          updatedAt
          status
          slug
          cover
          topics {
            id
            mediaFromTime
            mediaToTime
          }
        }
      }
      cover
      desc
      id
      name
      schoolId
      status
      slug
      totalTime
      playlistAssign {
        id
        metadata
        assignTo
        type
        courseEnrolls {
          course {
            id
            slug
            updatedAt
            courseVersionIds
          }
          status
          startDate
          endDate
          verifyAt
          insertedAt
          user {
            id
          }
          topicEnrolls {
            score
            currentTime
            status
          }
        }
        updatedAt
      }
      insertedAt
      updatedAt
    }
  }
`

export const GET_PLAYLIST_DETAIL_ACTIVITIES = gql`
  query userActivityHistories($courseId: Int, $limit: Int, $page: Int, $targetId: Int) {
    userActivityHistories(targetType: PLAYLIST, courseId: $courseId, limit: $limit, page: $page, targetId: $targetId) {
      data {
        action
        updatedAt
        changes
        user {
          ...User
        }
      }
      meta {
        total
        limit
        page
      }
    }
  }
  ${User}
`
export const GET_PLAYLISTS_LIST = gql`
  query academyPlaylists(
    $schoolIds: [Int!]!
    $limit: Int
    $page: Int
    $search: String
    $statuses: [PlaylistStatus]
    $sortField: PlaylistAllowedSortField
    $sortDirection: SortDirection
  ) {
    academyPlaylists(
      schoolIds: $schoolIds
      page: $page
      limit: $limit
      search: $search
      statuses: $statuses
      sortField: $sortField
      sortDirection: $sortDirection
    ) {
      data {
        name
        id
        desc
        slug
        status
        insertedAt
        updatedAt
        userId
        school {
          id
          name
        }
        playlistAssign {
          courseEnrolls {
            userId
          }
          id
          type
          assignTo
        }
        coursePlaylists {
          course {
            id
          }
        }
      }
      meta {
        total
        limit
        page
      }
    }
  }
`

export const GET_MY_PLAYLIST_ASSIGNERS = gql`
  query academyMyPlaylistAssigners {
    academyMyPlaylistAssigners {
      id
      fullName
      personalProfiles {
        name
        school {
          id
          parentId
        }
        media {
          url
        }
      }
    }
  }
`
